export default __webpack_public_path__ + "static/media/jaisalmer2.eb9b6390.jpg";